import { render, staticRenderFns } from "./owner-picker.vue?vue&type=template&id=9bd313dc&"
import script from "./owner-picker.vue?vue&type=script&lang=js&"
export * from "./owner-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports